import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-05ebfd3e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    ref: "slideshowWrapper",
    class: "slideshow-wrapper"
};
const _hoisted_2 = { ref: "slideshowBottom" };
const _hoisted_3 = { class: "slideshow-wrapper" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_SlideShowTopBar = _resolveComponent("SlideShowTopBar");
    const _component_EditorCell = _resolveComponent("EditorCell");
    const _component_SlideShowBottomBar = _resolveComponent("SlideShowBottomBar");
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass([
            'row-container flex-container',
            _ctx.blockWidthClass,
            'grid-slides-' + _ctx.gridSlides,
            { 'is-grid-view': _ctx.isGridView },
        ]),
        onMouseover: _cache[5] || (_cache[5] =
            //@ts-ignore
            (...args) => (_ctx.handleMouseOver && _ctx.handleMouseOver(...args))),
        onMouseout: _cache[6] || (_cache[6] =
            //@ts-ignore
            (...args) => (_ctx.handleMouseOut && _ctx.handleMouseOut(...args)))
    }, [
        _createElementVNode("div", {
            class: _normalizeClass(['slideshow-content', _ctx.blockWidthClass, { 'is-preview': _ctx.isPreview }])
        }, [
            _createElementVNode("div", _hoisted_1, [
                (_ctx.isSmallScreen && !_ctx.isLightboxView)
                    ? (_openBlock(), _createBlock(_component_SlideShowTopBar, {
                        key: 0,
                        "block-width-class": _ctx.blockWidthClass,
                        "is-grid-view": _ctx.isGridView,
                        route: _ctx.lightboxRoute,
                        "is-lightbox-view": _ctx.isLightboxView,
                        onToggleGridView: _ctx.handleToggleGridView,
                        onToggleLightbox: _cache[0] || (_cache[0] = ($event) => (_ctx.handleToggleLightBoxView(true)))
                    }, null, 8, ["block-width-class", "is-grid-view", "route", "is-lightbox-view", "onToggleGridView"]))
                    : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cells, (cell, index) => {
                    return (_openBlock(), _createBlock(_component_EditorCell, {
                        key: cell.id,
                        class: "slide",
                        "transition-name": _ctx.transitionName,
                        "block-width-class": _ctx.blockWidthClass,
                        "cell-type": cell.type,
                        nodes: cell.nodes,
                        "current-slide": _ctx.currentSlide,
                        "is-grid-view": _ctx.isGridView,
                        "row-type": _ctx.RowType.SlideShow,
                        "parent-first-child": _ctx.isParentFirstChild(index),
                        "parent-last-child": _ctx.isParentLastChild(index),
                        "is-block-toggled": _ctx.isBlockToggled,
                        "page-width": _ctx.pageWidth,
                        onClick: _ctx.handleClick,
                        onObserveNodeVisibility: ($event) => (_ctx.$emit('observe-node-visibility', Object.assign(Object.assign({}, $event), { cellId: cell.id }))),
                        onMousedown: _ctx.handleDragStart,
                        onMouseup: _ctx.handleDragEnd,
                        onTouchstart: _ctx.handleDragStart,
                        onTouchend: _ctx.handleDragEnd,
                        onFetchNewImage: ($event) => (_ctx.$emit('fetch-new-image', Object.assign(Object.assign({}, $event), { targetCellId: cell.id })))
                    }, null, 8, ["transition-name", "block-width-class", "cell-type", "nodes", "current-slide", "is-grid-view", "row-type", "parent-first-child", "parent-last-child", "is-block-toggled", "page-width", "onClick", "onObserveNodeVisibility", "onMousedown", "onMouseup", "onTouchstart", "onTouchend", "onFetchNewImage"]));
                }), 128)),
                (!_ctx.isPreview)
                    ? (_openBlock(), _createBlock(_component_SlideShowBottomBar, {
                        key: 1,
                        "block-width-class": _ctx.blockWidthClass,
                        "is-grid-view": _ctx.isGridView,
                        "current-slide": _ctx.currentSlide,
                        "is-selected": _ctx.isMouseOver,
                        slides: _ctx.slides,
                        "is-sticky": _ctx.isSticky,
                        "is-small-screen": _ctx.isSmallScreen,
                        route: _ctx.lightboxRoute,
                        "is-lightbox-view": _ctx.isLightboxView,
                        "grid-slides": _ctx.gridSlides,
                        onSlide: _ctx.slide,
                        onToggleGridView: _ctx.handleToggleGridView,
                        onToggleLightbox: _cache[1] || (_cache[1] = ($event) => (_ctx.handleToggleLightBoxView(true)))
                    }, null, 8, ["block-width-class", "is-grid-view", "current-slide", "is-selected", "slides", "is-sticky", "is-small-screen", "route", "is-lightbox-view", "grid-slides", "onSlide", "onToggleGridView"]))
                    : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_2, null, 512)
            ], 512)
        ], 2),
        _withDirectives(_createElementVNode("div", {
            ref: "lightboxContainerRef",
            class: _normalizeClass([
                'row-container lightbox-container',
                _ctx.blockWidthClass,
                'grid-slides-' + _ctx.gridSlides,
                { 'is-grid-view': _ctx.isGridView },
            ]),
            onMousemove: _cache[4] || (_cache[4] =
                //@ts-ignore
                (...args) => (_ctx.handleShowToolbar && _ctx.handleShowToolbar(...args)))
        }, [
            (_ctx.isSmallScreen)
                ? (_openBlock(), _createBlock(_component_SlideShowTopBar, {
                    key: 0,
                    "block-width-class": _ctx.blockWidthClass,
                    "is-grid-view": _ctx.isGridView,
                    "is-lightbox-view": _ctx.isLightboxView,
                    route: _ctx.lightboxRoute,
                    onToggleGridView: _ctx.handleToggleGridView,
                    onToggleLightbox: _cache[2] || (_cache[2] = ($event) => (_ctx.handleToggleLightBoxView(false)))
                }, null, 8, ["block-width-class", "is-grid-view", "is-lightbox-view", "route", "onToggleGridView"]))
                : _createCommentVNode("", true),
            _createElementVNode("div", {
                class: _normalizeClass(['slideshow-content lightbox', _ctx.blockWidthClass])
            }, [
                _createElementVNode("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cells, (cell, index) => {
                        return (_openBlock(), _createBlock(_component_EditorCell, {
                            key: cell.id,
                            class: "slide",
                            "transition-name": _ctx.transitionName,
                            "block-width-class": _ctx.blockWidthClass,
                            "cell-type": cell.type,
                            nodes: cell.nodes,
                            "current-slide": _ctx.currentSlide,
                            "is-grid-view": _ctx.isGridView,
                            "row-type": _ctx.RowType.SlideShow,
                            "parent-first-child": _ctx.isParentFirstChild(index),
                            "parent-last-child": _ctx.isParentLastChild(index),
                            "is-block-toggled": _ctx.isBlockToggled,
                            "page-width": _ctx.pageWidth,
                            onClick: _ctx.handleClick,
                            onObserveNodeVisibility: ($event) => (_ctx.$emit('observe-node-visibility', Object.assign(Object.assign({}, $event), { cellId: cell.id }))),
                            onMousedown: _ctx.handleDragStart,
                            onMouseup: _ctx.handleDragEnd,
                            onTouchstart: _ctx.handleDragStart,
                            onTouchend: _ctx.handleDragEnd,
                            onFetchNewImage: ($event) => (_ctx.$emit('fetch-new-image', Object.assign(Object.assign({}, $event), { targetCellId: cell.id })))
                        }, null, 8, ["transition-name", "block-width-class", "cell-type", "nodes", "current-slide", "is-grid-view", "row-type", "parent-first-child", "parent-last-child", "is-block-toggled", "page-width", "onClick", "onObserveNodeVisibility", "onMousedown", "onMouseup", "onTouchstart", "onTouchend", "onFetchNewImage"]));
                    }), 128))
                ])
            ], 2),
            (!_ctx.isPreview)
                ? (_openBlock(), _createBlock(_component_SlideShowBottomBar, {
                    key: 1,
                    "is-grid-view": _ctx.isGridView,
                    class: _normalizeClass({ 'show-bar': _ctx.showToolbar }),
                    "current-slide": _ctx.currentSlide,
                    "is-lightbox-view": _ctx.isLightboxView,
                    "is-small-screen": _ctx.isSmallScreen,
                    route: _ctx.lightboxRoute,
                    slides: _ctx.slides,
                    "grid-slides": _ctx.gridSlides,
                    onSlide: _ctx.slide,
                    onToggleGridView: _ctx.handleToggleGridView,
                    onToggleLightbox: _cache[3] || (_cache[3] = ($event) => (_ctx.handleToggleLightBoxView(false)))
                }, null, 8, ["is-grid-view", "class", "current-slide", "is-lightbox-view", "is-small-screen", "route", "slides", "grid-slides", "onSlide", "onToggleGridView"]))
                : _createCommentVNode("", true)
        ], 34), [
            [_vShow, _ctx.isLightboxView]
        ])
    ], 34));
}
